import React from 'react'
import { NavLink, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import { cn } from 'shared/util/cn'
import { useAuth } from 'context/AuthContext'
import { PERMISSIONS, hasPermission } from 'shared/util/permissions'
import { IconChart, IconScan, IconUsers } from 'shared/components/icons'

const GRID_COLS = ['grid-cols-1', 'grid-cols-2', 'grid-cols-3', 'grid-cols-4', 'grid-cols-5']

export function useNavItems(eventId) {
  const { user } = useAuth()
  const items = [
    { to: `/events/${eventId}`, label: 'Scan', icon: IconScan, end: true, show: true },
    { to: `/events/${eventId}/reports`, label: 'Reports', icon: IconChart, show: hasPermission(user, eventId, PERMISSIONS.GET_REPORT) },
    { to: `/events/${eventId}/users`, label: 'Users', icon: IconUsers, show: hasPermission(user, eventId, PERMISSIONS.GET_REPORT) }
  ]
  return items.filter((item) => item.show)
}

function NavItems({ eventId, className, itemClass }) {
  const items = useNavItems(eventId)
  return (
    <nav className={className}>
      {items.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            cn(itemClass, isActive ? 'text-theme' : 'text-muted')
          }
        >
          <Icon className="h-5 w-5" />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  )
}

NavItems.propTypes = {
  eventId: PropTypes.string,
  className: PropTypes.string,
  itemClass: PropTypes.string
}

export function BottomNav() {
  const { eventId } = useParams()
  const items = useNavItems(eventId)
  if (!eventId) return null
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-surface/95 backdrop-blur lg:hidden" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <NavItems
        eventId={eventId}
        className={cn('grid', GRID_COLS[Math.max(items.length, 1) - 1])}
        itemClass="flex min-h-14 flex-col items-center justify-center gap-1 text-xxs font-semibold"
      />
    </div>
  )
}

export function SideRail() {
  const { eventId } = useParams()
  if (!eventId) return null
  return (
    <aside className="sticky top-0 hidden h-dvh w-56 shrink-0 border-r border-line bg-surface p-4 lg:flex lg:flex-col">
      <p className="mb-6 px-2 text-xs font-bold uppercase tracking-widest text-theme">Gate Scanner</p>
      <NavItems
        eventId={eventId}
        className="flex flex-col gap-1"
        itemClass="flex min-h-tap items-center gap-3 rounded-2xl px-3 text-sm font-semibold hover:bg-elevated"
      />
    </aside>
  )
}
